// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__P6VUX","loader":"Button_loader__Frb8s","play":"Button_play__Yt+2N","iconContainer":"Button_iconContainer__JVDKT","icon":"Button_icon__sfQWx"};